

























/**
 * Header de satélite
 *
 * ARCHIVO DEFINIDO EN REPOSITORIO CORE, NO SE DEBE MODIFICAR EN SATÉLITES PARTICULARES.
 */

import Vue from 'vue';
import { USER_MUTATION_SET_USER } from '@/store/user/index.types';
import { AUTH_SERVICE } from '@/services/auth.service';
import { getLogoSrc } from '../brand.consts';

export default Vue.extend({
  data() {
    return {
      logo_src: getLogoSrc()
    };
  },
  computed: {
    usuario(){
      return this.$store.getters.user;
    }
  },
  methods:{
    cerrarSesion(){
      AUTH_SERVICE.desloguearse().then(() => {
        this.$store.commit(USER_MUTATION_SET_USER, null);
        this.$router.push('/login');
      });
    }
  }
});
